// import { Logger } from '@vue-storefront/core';

import { Middleware } from '@nuxt/types';

const middleware: Middleware = (context: any) => {
  // console.log('[middleware-is-authenticated.ts]------- context:', context);
  if (!context.$cookies.get('token')) {
    const homepage = context.localeRoute({ name: 'home' });
    context.redirect(homepage);
  }
};
export default middleware;
